module.exports = __webpack_public_path__ + "img/47.0de61851.png";